import { supabase } from './supabase';

export type DeleteAccountResult = 'deleted' | 'active_subscription' | 'admin_account' | 'failed';

/** Permanently deletes the signed-in user's account and data, then clears the local session. */
export async function deleteAccount(): Promise<DeleteAccountResult> {
  if (!supabase) return 'failed';
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  if (!token) return 'failed';

  const url = import.meta.env.VITE_SUPABASE_URL as string;
  try {
    const res = await fetch(`${url}/functions/v1/delete-account`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ confirm: 'DELETE' }),
    });
    if (res.status === 409) return 'active_subscription';
    if (res.status === 403) return 'admin_account';
    if (!res.ok) return 'failed';
  } catch {
    return 'failed';
  }
  // The server-side session is already gone with the user; only local state remains.
  await supabase.auth.signOut({ scope: 'local' });
  return 'deleted';
}
